import React from 'react';
import { Button } from 'antd';
import { FeatureText, FeatureMsgWrapper, ContactBtnRow } from './styled';

const FeatureCheck = ({ featureName }: { featureName?: string }) => {
  const contactConviva = () => {
    window.open('/app/pulse/support', '_blank');
  };

  return (
    <FeatureMsgWrapper id="no-feature-access">
      <FeatureText>
        {featureName || 'This feature'} is not included in your company’s product packaging. Contact
        your Conviva representative for more information.
      </FeatureText>
      <ContactBtnRow>
        <Button type="primary" onClick={contactConviva}>
          Contact Conviva
        </Button>
      </ContactBtnRow>
    </FeatureMsgWrapper>
  );
};

export default FeatureCheck;
